import { useEffect, useState } from "react";
import { Link, useLocation } from "@tanstack/react-router";
import { ArrowRight, Compass } from "lucide-react";

// Pages where the bar would be redundant or distracting.
const HIDDEN_ON = ["/pricing", "/find-your-plan", "/payment-success", "/auth", "/freevisasessions", "/visa-readiness"];

export function MobileQuickActionBar() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const hidden = HIDDEN_ON.some((p) => pathname === p || pathname.startsWith(p + "/")) || pathname.startsWith("/receipt");

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (hidden) return null;

  return (
    <div
      className={
        "md:hidden fixed bottom-0 left-0 w-full z-40 border-t border-border bg-background/90 backdrop-blur-md transition-all duration-300 " +
        (visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full pointer-events-none")
      }
      style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }}
      aria-hidden={!visible}
    >
      {/* Right padding leaves room for the chat button */}
      <div className="flex items-center gap-2 pl-3 pr-20 pt-2.5">
        <Link
          to="/find-your-plan"
          tabIndex={visible ? 0 : -1}
          className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full border border-border bg-card px-3 py-2.5 text-xs font-semibold text-foreground"
        >
          <Compass className="h-3.5 w-3.5 text-primary" /> Find plan (60s)
        </Link>
        <Link
          to="/pricing"
          hash="pricing"
          tabIndex={visible ? 0 : -1}
          className="flex-1 inline-flex items-center justify-center gap-1 rounded-full bg-gradient-cta px-3 py-2.5 text-xs font-semibold text-primary-foreground shadow-glow"
        >
          Enroll · ₹3,000+ <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
